module.exports = __webpack_public_path__ + "media/images/flags/CM-1cf33e4a56346abfef6e929aa4e8659c.svg";